module.exports = __webpack_public_path__ + "static/media/hero-image00.bbc33b2e.png";